import request from '@/request'

const state = {
	// 点击第一列，激活的索引
	ksmwccyb_active_index: '',
	ks1hfc6b_condition: [],
	ksk9lzmn_value_tree: {
		lists: [],
	},
	ksk9lzmn_value_tree_checked: {
		lists: []
	},
	// 监听字段，打开对应的第二列
	active_second_column: {
		field: '',
		times: 0,
		index: 0,
	}
}
const mutations = {
	ksmwccyb_active_index(state, payload) {
		state.ksmwccyb_active_index = payload
	},
	ks1hfc6b_condition(state, payload) {
		state.ks1hfc6b_condition = payload
	},
	ksk9lzmn_value_tree(state, payload) {
		state.ksk9lzmn_value_tree = payload
	},
	ksk9lzmn_value_tree_checked(state, payload) {
		state.ksk9lzmn_value_tree_checked = payload
	},
	active_second_column(state, payload) {
		state.active_second_column = payload
	}
}
const actions = {
	// 获取-筛选条件第一列的数据
	async ks1hfc6b_condition({ commit, getters }) {
		let tmpdbid = getters.kstq7ueu_dbid;
		if (!tmpdbid) {
			return;
		}
		let res = await request.get('/options/index', {
			dbid: tmpdbid
		})

		commit('ks1hfc6b_condition', res.data);
	},
	// 第二列字段的可选值，树型结构
	async ksk9lzmn_value_tree({ commit, state }, { field_id, input_val, start_date, end_date, page }) {
		let params = {
			field_id,
			page: page || 1,
		};
		if (input_val) {
			params.q = input_val
		}
		if (start_date) {
			params.start_date = start_date
		}
		if (end_date) {
			params.end_date = end_date
		}

		let res = await request.get('/options/lists', params)

		if (res.state === 0) {
			// 如果已经选中的条件被置顶,则删除返回中的此条件，否则选项会冗余。!input_val：有输入参数则不执行此if
			if (state.ksk9lzmn_value_tree_checked.lists.length > 0 && !input_val) {
				state.ksk9lzmn_value_tree_checked.lists.forEach(v => {
					res.data.lists.forEach((vv, kk) => {
						if (vv.value == v.value) {
							res.data.lists.splice(kk, 1);
						}
					});
				});
			}
			// 正常继续
			if (params.page > 1) {
				commit('ksk9lzmn_value_tree', {
					...state.ksk9lzmn_value_tree,
					...res.data,
					lists: [
						...state.ksk9lzmn_value_tree.lists,
						...res.data.lists,
					]
				});
			} else {
				commit('ksk9lzmn_value_tree', res.data);
			}
		}

	},
}

export default {
	state,
	mutations,
	actions
}
